import React from "react";
import Switch, { SwitchProps } from "@mui/material/Switch";
import { styled } from "@mui/system";
import { Box } from "@mui/material";

const CustomSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(() => ({
  width: "48px",
  height: "28px",
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: "4.5px",
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(21px)",
      color: "#F05802",
      "& + .MuiSwitch-track": {
        backgroundColor: "white",
        opacity: 1,
        border: "2px solid #3E3E3E",
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#F05802",
      border: "1px solid #F05802",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: "#F05802",
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: "18px",
    height: "18px",
    color: "#F05802",
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "white",
    opacity: 1,
    border: "2px solid #3E3E3E",
    height: "24px",
    width: "48px",
  },
}));

interface CustomSwitchProps {
  fieldName: string;
  isChecked: boolean;
  handleChange: (field: string, value: any) => void;
}

const CustomizedSwitch = (props: CustomSwitchProps) => {
  const { fieldName, isChecked, handleChange } = props;

  return (
    <Box>
      <CustomSwitch
        checked={isChecked}
        onChange={() => {
          handleChange(fieldName, !isChecked);
        }}
        name={fieldName}
      />
    </Box>
  );
};

export default CustomizedSwitch;
